import attachOptFormContext from '../utils/optFormContext';
import attachSelectContext from '../utils/selectContext';
import attachLanguageSelectContext from '../utils/languageSelectContext';

export { renderLogin, renderSignup } from '../reactApps/prelogin';

function handleHowItWorksVideo () {
  const $iframe = $('iframe');
  // this code allows auto play to happen only with the users click
  const vidsrc = `${$iframe.attr('src')}&autoplay=1`;

  $(document).on('opening', '.remodal', () => {
    $iframe.attr('src', vidsrc);
  });

  $(document).on('closing', '.remodal', () => {
    $iframe.attr('src', '');
  });
}

function attachContext () {
  attachSelectContext();
  attachOptFormContext();
  attachLanguageSelectContext();
  handleHowItWorksVideo();
}

document.addEventListener('DOMContentLoaded', attachContext, false);
